var exports = {
  "m": "BaseChangeNicknameModal.module__clearButton___R2Z6RU",
};

module.exports = exports;
